export default __webpack_public_path__ + "static/media/applied-jobs.a98f9529.svg";